import { useMemo } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { getPartnerProductPricesCount } from '@apis/partner';
import type { GetProductsParams } from '@apis/product';

import { dropEmptyValues } from '@utils/common';

const SEARCH_KEYS: Array<keyof GetProductsParams> = [
  'productCode',
  'productName',
  'stockId',
  'countryId',
  'productStatus',
  'productSaleType',
];

export const usePartnerProductPriceCount = ({
  partnerId,
  searchParam,
}: {
  partnerId: number;
  searchParam: GetProductsParams;
}) => {
  /**
   * Use the same cleaned params that the list query uses,
   * so count/list caches remain consistent and predictable.
   */
  const cleaned = useMemo(
    () => dropEmptyValues(searchParam, SEARCH_KEYS),
    [searchParam],
  );

  const queryOptions: UseQueryOptions<number, Error> = {
    queryKey: ['partnerProductPriceCount', partnerId, cleaned],
    queryFn: () => getPartnerProductPricesCount(partnerId, cleaned),
    enabled: Boolean(partnerId),
  };

  return useQuery(queryOptions);
};
